import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import handleOpenWhatsApp from 'services/whatsappService';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import {
  packages,
  buildPackageWhatsAppMessage,
  WHATSAPP_PHONE,
} from '../cherryWebContent';

const Packages = () => {
  const theme = useTheme();

  const choosePlan = (plan) => {
    handleOpenWhatsApp(null, buildPackageWhatsAppMessage(plan.name), WHATSAPP_PHONE);
  };

  return (
    <Box id="paquetes" py={{ xs: 2, md: 3 }}>
      <SectionHeader
        overline={packages.overline}
        title={packages.title}
        subtitle={packages.subtitle}
        icon="money"
      />

      <Grid container spacing={3} alignItems="stretch">
        {packages.plans.map((plan) => (
          <Grid item xs={12} md={4} key={plan.id}>
            <Box
              data-aos="fade-up"
              height="100%"
              display="flex"
              flexDirection="column"
              p={{ xs: 3, md: 3.5 }}
              borderRadius={3}
              position="relative"
              overflow="hidden"
              bgcolor={
                plan.featured
                  ? alpha(theme.palette.primary.main, 0.04)
                  : alpha(theme.palette.common.white, 0.92)
              }
              border={`1px solid ${
                plan.featured
                  ? alpha(theme.palette.primary.main, 0.35)
                  : theme.palette.divider
              }`}
              boxShadow={
                plan.featured
                  ? `0 22px 50px ${alpha(theme.palette.primary.main, 0.16)}`
                  : `0 12px 32px ${alpha(theme.palette.common.black, 0.05)}`
              }
            >
              {plan.badge ? (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 18,
                    right: 18,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 999,
                    bgcolor: plan.featured
                      ? theme.palette.secondary.main
                      : theme.palette.primary.main,
                    color: 'common.white',
                    fontSize: 11,
                    fontWeight: 800,
                    letterSpacing: 0.3,
                    maxWidth: '48%',
                    textAlign: 'center',
                    lineHeight: 1.25,
                  }}
                >
                  {plan.badge}
                </Box>
              ) : null}

              <Typography
                variant="caption"
                sx={{ fontWeight: 800, color: 'secondary.main', letterSpacing: 0.6, pr: plan.badge ? 12 : 0 }}
              >
                {plan.tag}
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 800, mt: 1, mb: 1, lineHeight: 1.25 }}>
                {plan.name}
              </Typography>
              <Typography color="textSecondary" sx={{ mb: 3, lineHeight: 1.6, fontSize: '0.95rem' }}>
                {plan.focus}
              </Typography>

              <Box display="flex" alignItems="baseline" gap={1} mb={0.5}>
                <Typography
                  component="span"
                  sx={{ fontWeight: 800, fontSize: { xs: '2.4rem', md: '2.6rem' }, lineHeight: 1 }}
                >
                  ${plan.price}
                </Typography>
                <Typography color="textSecondary" sx={{ fontWeight: 700 }}>
                  USD
                </Typography>
              </Box>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                {plan.priceNote}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                  color: 'secondary.main',
                  mb: 3,
                }}
              >
                Entrega: {plan.delivery}
              </Typography>

              <Divider sx={{ mb: 2.5 }} />

              <Box flex={1} mb={3}>
                {plan.rows.map((row) => (
                  <Box key={row.label} mb={2}>
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 800, color: 'text.secondary', letterSpacing: 0.5 }}
                    >
                      {row.label}
                    </Typography>
                    <Typography variant="body2" sx={{ lineHeight: 1.55, mt: 0.35 }}>
                      {row.value}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Button
                variant="contained"
                color={plan.featured ? 'secondary' : 'primary'}
                size="large"
                fullWidth
                startIcon={<WhatsAppIcon />}
                onClick={() => choosePlan(plan)}
                sx={{
                  py: 1.5,
                  fontWeight: 800,
                  borderRadius: 2,
                  boxShadow: plan.featured
                    ? `0 12px 28px ${alpha(theme.palette.secondary.main, 0.35)}`
                    : undefined,
                }}
              >
                {plan.cta}
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Packages;
